module.exports = __webpack_public_path__ + "static/media/database.8e12b839.svg";